module.exports = __webpack_public_path__ + "img/a_logo@2x.25971a60.png";